import {h} from 'preact'
import { Modal, Form, Input, DatePicker, Select, Row, Col, Button, Space, Tag } from 'antd';
import { SERVICE_OPTIONS } from '../constants/licenseConstants';
import dayjs from 'dayjs';

const { Option } = Select;

const LicenseKeyForm = ({
                            visible,
                            onCancel,
                            onSubmit,
                            editingKey,
                            loading,
                            form
                        }) => {
    return (
        <Modal
            title={editingKey ? 'Edit License Key' : 'Create New License Key'}
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={600}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onSubmit}
                style={{ marginTop: '16px' }}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="service_name"
                            label="Service Name"
                            rules={[{ required: true, message: 'Please select a service' }]}
                        >
                            <Select placeholder="Select service">
                                {SERVICE_OPTIONS.map(option => (
                                    <Option key={option.value} value={option.value}>
                                        <Tag color={option.color}>{option.label}</Tag>
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="user"
                            label="User/Client Name"
                            rules={[
                                { required: true, message: 'Please enter user name' },
                                { pattern: /^[a-zA-Z0-9_-]+$/, message: 'Only letters, numbers, underscore and dash allowed' }
                            ]}
                        >
                            <Input placeholder="e.g., halykbank" />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    name="expire_at"
                    label="Expiration Date"
                    rules={[{ required: true, message: 'Please select expiration date' }]}
                >
                    <DatePicker
                        showTime
                        style={{ width: '100%' }}
                        placeholder="Select expiration date and time"
                        disabledDate={(current) => current && current.isBefore(dayjs(), 'day')}
                    />
                </Form.Item>

                {editingKey && (
                    <Form.Item
                        name="license_key"
                        label="License Key"
                        rules={[{ required: true, message: 'Please enter license key' }]}
                    >
                        <Input.TextArea
                            rows={3}
                            placeholder="License key will be auto-generated for new keys"
                        />
                    </Form.Item>
                )}

                <div style={{ marginBottom: 0, textAlign: 'right' }}>
                    <Space>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            {editingKey ? 'Update' : 'Create'} License Key
                        </Button>
                    </Space>
                </div>
            </Form>
        </Modal>
    );
};

export default LicenseKeyForm;